<template>
	<div v-if="show" class="info-box">
		<div v-html="text"></div>
		<div
			@click="closeInfo()"
			class="info-box-close"
		>
			<span :data-tooltip="translations.labels.dismiss">
				<i class="el-icon-close" />
			</span>
		</div>
	</div>
</template>

<script>
import { _closeInfo } from '@/services/api/account'

export default {
    name: 'Info',
	props: {
		text: String,
		type: String
	},
	data () {
		return {
			show: true
		}
	},
	mounted () {
		this.show = !this.user.closedInfo.hasOwnProperty(this.type)
	},
	methods: {
		closeInfo () {
			let userData = this.user
			userData.closedInfo[this.type] = true
			_closeInfo(userData.closedInfo)
				.then(() => {
					this.show = false
					this.$store.dispatch('setUser', userData)
				})
		}
	}
}
</script>

<style lang="scss" scoped>
.info-box {

	background-color: $color-background;
	border-radius: 6px;
	color: lighten($color-text, 20%);
	font-size: $font-size;
	line-height: 1.5;
	margin: 30px 30px 0;
	padding: 20px 60px 20px 30px;
	position: relative;

	@include breakpoint(sm) {
		margin: 20px 20px 0;
	}

	&-close {

		border-radius: 0 6px 6px 0;
		cursor: pointer;
		@include flex(flex, row, wrap, center, center);
		font-size: 24px;
		height: 100%;
		@include position($position: absolute, $top: 0, $right: 0);
		transition: background-color .3s ease;
		width: 50px;

		&:hover {
			color: $color-1;
			background-color: darken($color-background, 3%);
		}

	}

}
</style>
